import WorkPatternInfoForm from './WorkPatternInfoForm';

export default WorkPatternInfoForm;
